import { POSITION } from "vue-toastification";

export default {
  Manager: [
    {
      name: "خانه",
      url: "/manager/dashboard",
      open: false,
      icon: "$Home",
    },

    {
      name: "سایت مشتریان",
      url: "/",
      open: false,
      icon: "mdi-web",
    },
    {
      name: "لیست انتشارات",
      url: "/manager/publishers",
      open: false,
      icon: "mdi-playlist-star",
    },
    // {
    //   name: "منابع انسانی",
    //   url: "/hrm/employees",
    //   open: false,
    //   icon: "$Customer",
    // },
    // {
    //   name: "فاکتور جدید",
    //   url: "/shop/newInvoice",
    //   open: false,
    //   icon: "$NewInvoice",
    // },
    {
      name: "محصولات",
      url: "/shop/products",
      open: false,
      icon: "$Products",
    },
    // {
    //   name: "تنوع‌ها",
    //   url: "/shop/VariantsList",
    //   open: false,
    //   icon: "$Bag2",
    // },
    // {
    //   name: "فاکتور فروش",
    //   url: "/shop/salesInvoices",
    //   open: false,
    //   icon: "$SalesInvoice",
    // },
    // {
    //   name: "نمودار فروش",
    //   url: "/shop/reports",
    //   open: false,
    //   icon: "$Chart",
    // },
    {
      name: "مشتریان",
      url: "/shop/customers",
      open: false,
      icon: "$Customer",
    },
    {
      name: "مدیریت ویدئو های اموزشی",
      url: "/manager/videos",
      open: false,
      icon: "mdi-video",
    },
    {
      name: "مدیریت اقساط",
      url: "/manager/installments",
      open: false,
      icon: "mdi-cash-lock",
    },
    {
      name: "مدیریت نویسندگان",
      url: "/manager/author",
      open: false,
      icon: "mdi-account-multiple",
    },
    // {
    //   name: "امور مالی",
    //   url: "#",
    //   icon: "$TrendUp",
    //   open: false,
    //   children: [
    //     {
    //       name: "مدیریت دریافت‌ها",
    //        url: "/shop/receives",
    //       icon: "$TrendUp",
    //   open: false,

    //     },
    //     {
    //       name: "مدیریت پرداخت‌ها",
    //        url: "/shop/payments",
    //       icon: "$TrendDown",
    //   open: false,

    //     },

    //   ],
    // },
    {
      name: "فروش‌های نقدی و اقساطی ",
      url: "/manager/salesManager",
      open: false,
      icon: "mdi-cellphone",
    },
    {
      name: "گزارش چک‌ها ",
      url: "/manager/cheque",
      open: false,
      icon: "mdi-cash",
    },
    // {
    //   name: "کمیسیون فروشنده‌ها",
    //   url: "/manager/sellerCommission",
    //   open: false,
    //   icon: "$Percent",
    // },
    // {

    //   name: "فروش‌های آنلاین ",
    //   url: "/manager/onlineSales",
    //   open: false,
    //   icon: "$Mobile",
    // },
    {
      name: " آمار بازدید‌ها ",
      url: "/shop/visitlogs",
      open: false,
      icon: "$EyeOn",
    },
    {
      name: "گزارش‌های فروشگاه",
      url: "/manager/ReportLists",
      open: false,
      icon: "mdi-chart-box",
    },
    {
      name: "هزینه ارسال",
      url: "/manager/deliveryCosts",
      open: false,
      icon: "mdi-truck-outline",
    },
    // {
    //   name: " دسته‌بندی‌ها ",
    //   url: "/manager/admincategories",
    //   open: false,
    //   icon: "$Category",
    // },

    {
      name: " نظرات ",
      url: "/manager/comments",
      open: false,
      icon: "$Chat",
    },
    {
      name: " درخواست‌های مشاوره ",
      url: "/manager/consultationrequests",
      open: false,
      icon: "$BrandIcon",
    },
    // {
    //   name: " بنر‌ها ",
    //   url: "/manager/banners",
    //   open: false,
    //   icon: "$PurpleChecked",
    // },
    // {
    //   name: "تنظیمات",
    //   url: "#",
    //   open: false,
    //   icon: "$Cog",
    //   children: [

    //     {
    //       name: "تغییر رمز عبور",
    //       url: "/manager/changePassword",
    //       open: false,
    //       icon: "$Key",
    //     },
    //   ],
    // },
  ],
  // shop: [
  //   {
  //     name: "خانه",
  //     url: "/shop/dashboard",
  //     open: false,
  //     icon: "$Home",
  //   },
  //   {
  //     name: "فاکتور جدید",
  //     url: "/shop/newInvoice",
  //     open: false,
  //     icon: "$NewInvoice",
  //   },
  //   {
  //     name: "محصولات",
  //     url: "/shop/products",
  //     open: false,
  //     icon: "$Products",
  //   },
  //   {
  //     name: "تنوع‌ها",
  //     url: "/shop/VariantsList",
  //     open: false,
  //     icon: "$Bag2",
  //   },
  //   {
  //     name: "فاکتور فروش",
  //     url: "/shop/salesInvoices",
  //     open: false,
  //     icon: "$SalesInvoice",
  //   },
  //   {
  //     name: "نمودار فروش",
  //     url: "/shop/reports",
  //     open: false,
  //     icon: "$Chart",
  //   },
  //   {
  //     name: "مشتریان",
  //     url: "/shop/customers",
  //     open: false,
  //     icon: "$Customer",
  //   },
  //   {
  //     name: "تنظیمات",
  //     url: "#",
  //     open: false,
  //     icon: "$Cog",
  //     children: [
  //       {
  //         name: "باشگاه مشتریان",
  //         url: "/shop/customersClub",
  //         open: false,
  //         icon: "$Star",
  //       },
  //       {
  //         name: "تغییر رمز عبور",
  //         url: "/shop/changePassword",
  //         open: false,
  //         icon: "$Key",
  //       },
  //     ],
  //   },
  // ],
  // sales: [
  //   {
  //     name: "فروش جدید",
  //     url: "/sales/newInvoice",
  //     open: false,
  //     icon: "$NewInvoice",
  //   },
  //   {
  //     name: "فاکتور فروش",
  //     url: "/sales/salesInvoices",
  //     open: false,
  //     icon: "$SalesInvoice",
  //   },
  //   {
  //     name: "محصولات",
  //     url: "/shop/products",
  //     open: false,
  //     icon: "$Products",
  //   },
  //   {
  //     name: "تنوع‌ها",
  //     url: "/shop/VariantsList",
  //     open: false,
  //     icon: "$Bag2",
  //   },
  //   {
  //     name: "تغییر رمزعبور",
  //     url: "/sales/changePassword",
  //     open: false,
  //     icon: "$Key",
  //   },
  // ],
};
